module.exports = __webpack_public_path__ + "static/media/tagging.dda35b8d.png";